import { resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
    label: _ctx.label,
    color: "primary",
    size: "sm",
    "no-caps": "",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', !_ctx.modelValue)))
  }, null, 8, ["label"])), [
    [_vShow, _ctx.total]
  ])
}